import apolloClient from '@/lib/apollo-client';
import { CREATE_PROVIDER_USER } from '@/lib/graphql/mutations/userMutations';
import { getCookie } from '@/utils/cookies';

export interface CreateProviderUserInput {
  username: string;
  email: string;
  title?: string;
  location?: string;
  mobile?: string;
}

export interface CreateProviderUserResponse {
  user: {
    id: string;
    username: string;
    email: string;
    roles: string[];
  };
  message: string;
  statusCode: number;
  generatedPassword: string;
}

export const createProviderUser = async (input: CreateProviderUserInput): Promise<CreateProviderUserResponse> => {
  const token = getCookie('token');
  
  try {
    const { data } = await apolloClient.mutate({
      mutation: CREATE_PROVIDER_USER,
      variables: { input },
      context: {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    });

    if (!data || !data.createProviderUser) {
      throw new Error('Failed to create provider user');
    }

    return data.createProviderUser;
  } catch (error) {
    console.error('Error creating provider user:', error);
    throw error;
  }
};
